var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0436 3.38645L15.3308 8.25965C15.416 8.44085 15.5852 8.56805 15.7832 8.59805L20.9456 9.38645C21.428 9.45965 21.626 10.0488 21.284 10.398L17.5112 14.2656C17.378 14.4024 17.318 14.5932 17.348 14.7816L18.2336 20.2104C18.314 20.7048 17.7896 21.0744 17.3516 20.832L12.7904 18.3108C12.6092 18.2112 12.3908 18.2112 12.2096 18.3108L7.64836 20.832C7.21036 21.0744 6.68476 20.7048 6.76636 20.2104L7.65196 14.7816C7.68316 14.5932 7.62196 14.4024 7.48876 14.2656L3.71596 10.3992C3.37396 10.0488 3.57196 9.46085 4.05436 9.38645L9.21676 8.59805C9.41476 8.56805 9.58396 8.44085 9.66916 8.25965L11.9564 3.38645C12.1724 2.92685 12.8276 2.92685 13.0436 3.38645Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6102e7078df2f5b8d2c3f0f4a02cfcd9.svg";
export { ForwardRef as ReactComponent };